import { getAddress, isAddress } from 'viem';

/**
 * Checked-in OFAC sanctioned address list for runtime lookups.
 *
 * Refresh it with `yarn update-sanctioned-addresses`.
 */
const sanctionedAddressValues = [
  /* SANCTIONED_ADDRESSES_START */
  '0x098B716B8Aaf21512996dC57EB0615e2383E2f96',
  '0xa0e1c89Ef1a489c9C7dE96311eD5Ce5D32c20E4B',
  '0x3Cffd56B47B7b41c56258D9C7731ABaDc360E073',
  '0x53b6936513e738f44FB50d2b9476730C0Ab3Bfc1',
  '0x35fB6f6DB4fb05e6A4cE86f2C93691425626d4b1',
  '0xF7B31119c2682c88d88D455dBb9d5932c65Cf1bE',
  '0x3e37627dEAA754090fBFbb8bd226c1CE66D255e9',
  '0x08723392Ed15743cc38513C4925f5e6be5c17243',
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x9F4cda013E354b8fC285BF4b9A60460cEe7f7Ea9',
  '0x3CBdeD43EFdAf0FC77b9C55F6fC9988fCC9b757d',
  '0xfEC8A60023265364D066a1212fDE3930F6Ae8da7',
  '0x7FF9cFad3877F21d41Da833E2F775dB0569eE3D9',
  '0xc2a3829F459B3Edd87791c74cD45402BA0a20Be3',
  '0x3AD9dB589d201A710Ed237c829c7860Ba86510Fc',
  '0x12D66f87A04A9E220743712cE6d9bB1B5616B8Fc',
  '0x47CE0C6eD5B0Ce3d3A51fdb1C52DC66a7c3c2936',
  '0x910Cbd523D972eb0a6f4cAe4618aD62622b39DbF',
  '0xA160cdAB225685dA1d56aa342Ad8841c3b53f291',
  '0xD4B88Df4D29F5CedD6857912842cff3b20C8Cfa3',
  '0xFD8610d20aA15b7B2E3Be39B396a1bC3516c7144',
  '0x07687e702b410Fa43f4cB4Af7FA097918ffD2730',
  '0x23773E65ed146A459791799d01336DB287f25334',
  '0x22aaA7720ddd5388A3c0A3333430953C68f1849b',
  '0x03893a7c7463AE47D46bc7f091665f1893656003',
  '0x2717c5e28cf931547B621a5dddb772Ab6A35B701',
  '0xD21be7248e0197Ee08E0c20D4a96DEBdaC3D20Af',
  '0x39D908dac893CBCB53Cc86e0ECc369aA4DeF1A29',
  '0x4F47Bc496083C727c5fbe3CE9CDf2B0f6496270c',
  '0x38735f03b30FbC022DdD06ABED01F0Ca823C6a94',
  '0x97B1043ABD9E6FC31681635166d430a458D14F9C',
  '0xb6f5ec1A0a9cd1526536D3F0426c429529471F40',
  /* SANCTIONED_ADDRESSES_END */
] as const;

const sanctionedAddresses = new Set<string>(sanctionedAddressValues);

export function normalizeAddressForComparison(address: string): string | null {
  const trimmedAddress = address.trim();
  if (!trimmedAddress) {
    return null;
  }

  const lowercasedAddress = trimmedAddress.toLowerCase();
  if (!isAddress(lowercasedAddress)) {
    return null;
  }

  return getAddress(lowercasedAddress);
}

export function isSanctionedAddress(address: string): boolean {
  const normalizedAddress = normalizeAddressForComparison(address);
  return (
    normalizedAddress !== null && sanctionedAddresses.has(normalizedAddress)
  );
}
